import { render, staticRenderFns } from "./Privacidade.vue?vue&type=template&id=e9c2ce5a&"
import script from "./Privacidade.vue?vue&type=script&lang=js&"
export * from "./Privacidade.vue?vue&type=script&lang=js&"
import style0 from "./Privacidade.vue?vue&type=style&index=0&id=e9c2ce5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports